export const API_PATH_apiUsersInvitationsDelete = '/services/users-invitations';
